import request from "@/utils/request";

/**
 * 行情数据列表获取
 */
export const getTxjlList = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/getDwzjgqtxjlList`,
  method: 'post',
  data,
  timeout: 1000000
})

/**
 * 行情数据导出
 */
export const exportTxjlList = (data) => request({
  url: `/yzdservice/enterprise/nbry/ywgn/exportDwzjgqtxjl`,
  method: 'post',
  responseType: 'blob',
  data,
  timeout: 1000000
})
